import { DeconvolutionOperation } from 'interfaces/study';
import { times } from 'lodash';

export const deconvolutionTypeToDefaultCoefficients = (
  deconvolutionType: DeconvolutionOperation['deconvolutionType']
): DeconvolutionOperation['coefficients'] =>
  deconvolutionType === 'cubic'
    ? [
        times(20, (n) => (n === 1 ? 1 : 0)) as [number, ...number[]],
        times(20, (n) => (n === 2 ? 1 : 0)) as [number, ...number[]],
        times(20, (n) => (n === 3 ? 1 : 0)) as [number, ...number[]],
      ]
    : [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1],
      ];

export const regexTestIsJSONFloat3x3Matrix =
  /^\[\s*\[\s*-?\d+(?:\.\d*)?\s*(?:,\s*-?\d+(?:\.\d*)?\s*)*\](?:\s*,\[\s*-?\d+(?:\.\d*)?\s*(?:,\s*-?\d+(?:\.\d*)?\s*){2}\]){2}\s*\]$/;

export const regexTestIsJSONFloat3x20Matrix =
  /^\[\s*\[\s*-?\d+(?:\.\d*)?\s*(?:,\s*-?\d+(?:\.\d*)?\s*)*\](?:\s*,\[\s*-?\d+(?:\.\d*)?\s*(?:,\s*-?\d+(?:\.\d*)?\s*){19}\]){2}\s*\]$/;

export const regexTestIsRGBVector = /^\[\s*-?\d+(?:\.\d+)?\s*,\s*-?\d+(?:\.\d+)?\s*,\s*-?\d+(?:\.\d+)?\s*\]$/;
